import { Controller } from "@hotwired/stimulus"

// Debounced live-submit for filter/search inputs. Attach to a form
// (or any element wrapping the inputs) and call `submit` on input:
//
//   <%= form_with url: ..., method: :get,
//         data: { controller: "live-submit",
//                 live_submit_delay_value: 300 } do %>
//     <input type="search" name="q"
//            data-action="input->live-submit#submit">
//   <% end %>
//
// Submitting on input means the user gets results as they type. When
// the user clears the field and pauses (or presses Enter on an empty
// box) the empty `q` lands on the server and the unfiltered list
// comes back.
export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  connect() {
    this._form = this.element.tagName === "FORM"
      ? this.element
      : this.element.closest("form")
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  submit() {
    if (!this._form) return
    if (this._timer) clearTimeout(this._timer)
    this._timer = setTimeout(() => {
      if (typeof this._form.requestSubmit === "function") {
        this._form.requestSubmit()
      } else {
        this._form.submit()
      }
    }, this.delayValue)
  }
}
